import React from 'react';
import RadioButton from '../../components/radio_button/radio_button';
import CONSTANTS from '../../common_constants.jsx';
import './package_size.less';

export default class PackageSizeDropdown extends React.Component{

  constructor(props){
    super(props);
    this.state={
      browseFilter: this.props.browseFilter
    }
  }

  getRadioButtonValue = (value) => {
    let radioButtonMap = {Small: 1, Medium: 2, Large: 3};
    let browseFilter = Object.assign({}, this.state.browseFilter);
    if(value != 'Extra Large'){
      browseFilter.packageSize = radioButtonMap[value];
    }else{
      browseFilter.packageSize = 4;
    }
    this.setState({browseFilter});
    this.props.updateParentStateCallback(browseFilter);
  }
  componentWillReceiveProps(newProps){
    this.setState({browseFilter: newProps.browseFilter});
  }

  render(){
    const {state} = this;
    let radioButtonArray = ['Small', 'Medium', 'Large', 'Extra Large'];
    let radioButtonDetails = ['Fits in a small backpack or carry-on bag.Less than 2 lbs.', 'Fits in a large duffel bag or carry-on suitcase. 2-5 lbs.',
    'Fits in a large suitcase that requires check-in. 5-20 lbs.', 'Needs to be shipped in the cargo area.20 - 50 lbs. May incur extra fees.' ];
    let selected;
    (state.browseFilter && state.browseFilter.hasOwnProperty('packageSize') && state.browseFilter.browseFilter != '')  ? (selected = state.browseFilter.packageSize -1) : (selected = null);
    return(
      <div className="popup">
        <RadioButton radioButtonNameArray = {radioButtonArray} selected={selected} radioButtonDetails = {radioButtonDetails}  radioButtonName={'checkbox'} getValueCallback = { this.getRadioButtonValue } />
      </div>
    )
  }

}



// WEBPACK FOOTER //
// app/browse_packages/browse_filter/package_size.jsx